import { Box, Zoom } from "@mui/material";
import { useInView } from "react-intersection-observer";

const AnimatedSection = ({ children,  threshold = 0.3 }) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold });

  return (
    <Box ref={ref}>
      <Zoom in={inView} timeout={1000}>
        <Box>{children}</Box>
      </Zoom>
    </Box>
  );
};

export default AnimatedSection;
